// src/App.js
import React, { useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { Spinner, Button, Container, Alert, Card, Navbar, Row, Col } from 'react-bootstrap';

const App = () => {
  const [image, setImage] = useState(null);
  const [resultImage, setResultImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    const validExtensions = ['image/jpeg', 'image/jpg', 'image/png'];

    if (selectedFile && validExtensions.includes(selectedFile.type)) {
      setImage(selectedFile);
      setError(null);
    } else {
      setError('Please upload a valid image file (.jpg, .jpeg, .png)');
    }
  };

  const handleImageUpload = async () => {
    if (!image) return;

    setLoading(true);
    setError(null);
    const formData = new FormData();
    formData.append('image_file', image);

    try {
      const response = await axios.post('https://api.remove.bg/v1.0/removebg', formData, {
        headers: {
          'X-Api-Key': 'FnLxtHJYVPCHZTVuz4RevnBv',
          'Content-Type': 'multipart/form-data',
        },
        responseType: 'blob',
      });

      const url = URL.createObjectURL(response.data);
      setResultImage(url);
    } catch (error) {
      console.error('Error removing background:', error);
      setError('Failed to remove background. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = resultImage;
    link.download = 'background_removed.png';
    link.click();
  };

  const handleReset = () => {
    setImage(null);
    setResultImage(null);
    setLoading(false);
    setError(null);
  };

  return (
    <Container className="app container-fluid">
      <Navbar bg="primary" variant="dark" className="app__navbar">
        <Navbar.Brand href="/" className="app__navbar-brand">
          <img
            src="https://removebgapp.techpulsz.com/logo-bg.svg"
            width="50"
            height="50"
            alt="Logo"
          />
          <span className="app__navbar-title">BG Remover</span>
        </Navbar.Brand>
        <Navbar.Brand href="https://www.behance.net/souvik0807" target="_blank" className="app__navbar-brand">
          <span className="app__navbar-title">About</span>
        </Navbar.Brand>
      </Navbar>

      {!resultImage && (
        <section className="app__description">
          <Col md={3} className="app__description-col">
            <img
              src="https://removebgapp.techpulsz.com/home-head-image.svg"
              width="200px"
              height="180px"
              alt="head-image"
            />
          </Col>
          <Col md={9} className="app__description-col">
            <div className="app__description-content">
              <h1 className="app__title"><span>Remove Background</span> From Your Image</h1>
              <p className="app__description-text">
                This app is using remove.bg free API to remove background from your image. You can upload your image and get the result in a few seconds.
              </p>
            </div>
          </Col>  
        </section>
      )}

      <Card className="app__card">
        <input type="file" accept=".jpg, .jpeg, .png" onChange={handleImageChange} className="app__file-input" />
        
        {error && <Alert variant="danger" className="app__error">{error}</Alert>}

        {image && (
          <Button onClick={handleImageUpload} variant="primary" disabled={loading} className="app__button-upload">
            {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Remove Background'}
          </Button>
        )}

        <Row className="app__images justify-content-center">
          {image && (
            <Col md={resultImage ? 6 : 8} className="app__image-col">
              <Card className="app__image-card">
                <Card.Body className="app__image-frame">
                  <h5 className="app__image-title">Original Image</h5>
                  <img
                    src={URL.createObjectURL(image)}
                    alt="Original"
                    className="app__image"
                  />
                </Card.Body>
              </Card>
            </Col>
          )}
          {resultImage && (
            <Col md={6} className="app__image-col">
              <Card className="app__image-card">
                <Card.Body className="app__image-frame">
                  <h5 className="app__image-title">Converted Image</h5>
                  <img
                    src={resultImage}
                    alt="Processed"
                    className="app__image"
                  />
                  <Button onClick={handleDownload} variant="success" className="app__button-download">
                    Download Image
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
        {resultImage && (
          <Button onClick={handleReset} variant="secondary" className="app__button-reset">
            Reset
          </Button>
        )}
      </Card>
      <footer className="app__footer">
        <p className="app__footer-text">© 2024 Background Remover App</p>
      </footer>
    </Container>
  );
};

export default App;
